import alterReplace from '@/functions/alterStrReplace'

const replaceSettingItem = (settingItems, roboArguments) => {
  return (message) => {
    if (typeof message === 'string') {
      // ロボ引用置換
      message = replaceRoboArguments(message, roboArguments)
      return message
        .replace(
          new RegExp('__applicant__', 'g'),
          alterReplace(settingItems.lsApplicant, false) ? settingItems.lsApplicant : ''
        )
        .replace(new RegExp('__email__', 'g'), alterReplace(settingItems.lsEmail, false) ? settingItems.lsEmail : '')
        .replace(new RegExp('__tel__', 'g'), alterReplace(settingItems.lsTel, false) ? settingItems.lsTel : '')
        .replace(new RegExp('__address__', 'g'), alterReplace(settingItems.lsAddress, false) ? settingItems.lsAddress : '')
        .replace(
          new RegExp('__furigana__', 'g'),
          alterReplace(settingItems.lsFurigana, false) ? settingItems.lsFurigana : ''
        )
        .replace(new RegExp('__yyyymmdd__', 'g'), alterReplace(settingItems.lsYyyymmdd, false) ? settingItems.lsYyyymmdd : '')
        .replace(new RegExp('__years__', 'g'), alterReplace(settingItems.lsYears, false) ? settingItems.lsYears : '')
        .replace(new RegExp('__shikaku__', 'g'), alterReplace(settingItems.lsShikaku, false) ? settingItems.lsShikaku : '')
        .replace(new RegExp('__career__', 'g'), alterReplace(settingItems.lsCareer, false) ? settingItems.lsCareer : '')
        .replace(new RegExp('__bikou__', 'g'), alterReplace(settingItems.lsBikou, false) ? settingItems.lsBikou : '')
        .replace(new RegExp('__date__', 'g'), alterReplace(settingItems.lsSchedule, false) ? settingItems.lsSchedule : '')
        .replace(new RegExp('__point__', 'g'), alterReplace(settingItems.lsPoint, false) ? settingItems.lsPoint : '')
    } else {
      return message
    }
  }
}

const replaceApplyMessage = (quoteWords, replaceItems, roboArguments) => {
  return (message) => {
    // ロボ引用置換
    message = replaceRoboArguments(message, roboArguments)
    return message
      .replace(new RegExp(quoteWords.name, 'g'), alterReplace(replaceItems.replaceName, false))
      .replace(new RegExp(quoteWords.furigana, 'g'), alterReplace(replaceItems.replaceFurigana, false))
      .replace(new RegExp(quoteWords.email, 'g'), alterReplace(replaceItems.replaceEmail, false))
      .replace(new RegExp(quoteWords.tel, 'g'), alterReplace(replaceItems.replaceTel, false))
      .replace(new RegExp(quoteWords.gender, 'g'), alterReplace(replaceItems.replaceGender, false))
      .replace(new RegExp(quoteWords.address, 'g'), alterReplace(replaceItems.replaceAddress, false))
      .replace(new RegExp(quoteWords.birth, 'g'), alterReplace(replaceItems.replaceBirth, false))
      .replace(new RegExp(quoteWords.message, 'g'), alterReplace(replaceItems.replaceMessage, false))
  }
}

const replacePulldownMessage = (replaceMessage, quoteWords, replaceItems, roboArguments) => {
  return (message) => {
    const keys = Object.keys(replaceItems)
    for (let k of keys) {
      if (quoteWords[k] && replaceItems[k]) message = message.replace(new RegExp(quoteWords[k], 'g'), alterReplace(replaceItems[k], false))
    }
    if (quoteWords.answer) message = message.replace(new RegExp(quoteWords.answer, 'g'), alterReplace(replaceMessage, false))
    // ロボ引用置換
    message = replaceRoboArguments(message, roboArguments)
    return message
  }
}

const replaceMessage = (replaceMessage, quoteWord, roboArguments) => {
  return (message) => {
    if (typeof message === 'string') {
      // ロボ引用置換
      message = replaceRoboArguments(message, roboArguments)
      return message.replace(new RegExp(quoteWord, 'g'), alterReplace(replaceMessage, false))
    } else {
      return message
    }
  }
}

const replaceRoboArguments = (text, roboArguments) => {
  if (roboArguments) {
    for (const arg of roboArguments) {
      text = text.replace(
        new RegExp(arg.key, 'g'),
        arg.value
      )
    }
  }
  // 置換できなかったロボ引用の引用文字列を削除する
  return text.replace(new RegExp(/__robo_quote\.([a-z0-9]+|[a-z]+)__/, 'g'), '')
}

const getGenderName = gender => {
  if (gender == 0) {
    return '未選択'
  } else if (gender == 1) {
    return '男性'
  } else if (gender == 2) {
    return '女性'
  } else if (gender == 3) {
    return '選択しない'
  }
}

const getBirthDateFormat = birth => {
  if (birth === 'Invalid date') {
    return ''
  } else if (birth != undefined) {
    if (typeof(birth) === "object") {
      return birth.getFullYear() + '/' + (birth.getMonth() + 1) + '/' + birth.getDate()
    } else {
      return birth
    }
  } else {
    return '-/-/-'
  }
}

const haveQuoteCheck = (text) => {
  return text.replace(new RegExp(/__(\d+|\d+\.[a-z0-9]+|[a-z]+)__/, 'g'), '')
}

// チェックボックス関連
const getCheckboxParameter = (scenarioData, replaceFunc, roboArguments) => {
  let paramInfoArr = []
  if (scenarioData.status === 13) {
    let replaceScenario = JSON.parse(JSON.stringify(scenarioData.parameter))
    for (let paramIdx in scenarioData.parameter) {
      if (replaceScenario[paramIdx].item_message) {
        paramInfoArr.push(
          {
            itemMessage: replaceFunc(replaceScenario[paramIdx].item_message, roboArguments),
            paramIdx: paramIdx,
          }
        )
      }
    }
  }
  return paramInfoArr
}

const replaceScenarioData = (scenarioData, replaceFunc, roboArguments) => {

  // messageの置換
  scenarioData.message = replaceFunc(scenarioData.message, roboArguments)

  // parameter内を置換したい場合は以下に記述
  // チェックボックスの場合
  getCheckboxParameter(scenarioData, replaceFunc, roboArguments)
    .map(v => (scenarioData.parameter[v.paramIdx].item_message = v.itemMessage))
  // プルダウン選択の場合
  if (scenarioData.status === 15) {
    for (let pullDown of scenarioData.parameter) {
      pullDown.title = replaceFunc(pullDown.title, roboArguments)
      for (let item of pullDown.items) {
        item.itemName = replaceFunc(item.itemName, roboArguments)
      }
    }
  }
  // カルーセルの場合
  if (scenarioData.status === 17) {
    for (const i in scenarioData.parameter) {
      for (const key in scenarioData.parameter[i]) {
        if (key === 'title' || key === 'contents' || key === 'button') {
          scenarioData.parameter[i][key] = replaceFunc(scenarioData.parameter[i][key], roboArguments)
        }
      }
    }
  }
  // 回答出力パーツ
  if (scenarioData.status === 19) {
    scenarioData.parameter.file_name = replaceFunc(scenarioData.parameter.file_name, roboArguments)
  }
  // 検索パーツの場合
  if (scenarioData.status === 20) {
    // デフォルト検索ワード
    // 初期設定をバックアップするための対応
    if(scenarioData.parameter.bk_default_search_word == undefined) {
      scenarioData.parameter.bk_default_search_word = scenarioData.parameter.default_search_word
    }
    if (scenarioData.parameter.default_search_word) {
      scenarioData.parameter.default_search_word = replaceFunc(scenarioData.parameter.default_search_word, roboArguments)
    }
    // 検索内容の入力
    for (let s in scenarioData.parameter.search) {
      for (let key in scenarioData.parameter.search[s]) {
        if (
          (key == 'description' || key == 'title' || key == 'keywords') &&
          scenarioData.parameter.search[s][key] != ''
        ) {
          scenarioData.parameter.search[s][key] = replaceFunc(scenarioData.parameter.search[s][key], roboArguments)
        }
      }
    }
    scenarioData.parameter.message = replaceFunc(scenarioData.parameter.message, roboArguments)
  }
  // PDFダウンロードパーツの場合
  if (scenarioData.status === 21) {
    scenarioData.parameter.file_name = replaceFunc(scenarioData.parameter.file_name, roboArguments)
  }
  return scenarioData
}

const getScenarioData = (scenarioData, settingItems, tempChatTalkHistory, roboArguments=null) => {
  for (let c of tempChatTalkHistory) {
    if (c.quoteWords != undefined && c.speaker == 'my') {
      if (c.status == 1 || c.status == 8) {
        // 1. 応募フォーム or 履歴書フォームのとき
        const replaceItems = {
          replaceName: c.quoteAnswers.name,
          replaceFurigana: c.quoteAnswers.furigana,
          replaceEmail: c.quoteAnswers.email,
          replaceTel: c.quoteAnswers.tel,
          replaceGender: getGenderName(c.quoteAnswers.gender),
          replaceAddress: c.quoteAnswers.address,
          replaceBirth: getBirthDateFormat(c.quoteAnswers.birth),
          replaceMessage: c.quoteAnswers.msg,
        }
        scenarioData = replaceScenarioData(scenarioData, replaceApplyMessage(c.quoteWords, replaceItems, roboArguments))
      }
      else if (c.status == 15) {
        // 2. プルダウンのとき
        scenarioData = replaceScenarioData(scenarioData, replacePulldownMessage(c.message, c.quoteWords, c.quoteAnswers, roboArguments))
      }
      else {
        // 3. それ以外のとき
        scenarioData = replaceScenarioData(scenarioData, replaceSettingItem(settingItems, roboArguments))
        scenarioData = replaceScenarioData(scenarioData, replaceMessage(c.message, c.quoteWords.answer, roboArguments))
      }
    }
  }
  // 3. 存在しない引用ワードを使った場合は表示しないようにする
  scenarioData = replaceScenarioData(scenarioData, haveQuoteCheck, roboArguments)
  return scenarioData
}

export default {
  getScenarioData,
}



// WEBPACK FOOTER //
// ./src/functions/makeScenarioFunc.js